import { React } from 'react';
import { MdOutlineEmail } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { PiInstagramLogoFill } from "react-icons/pi";

const Footer = () => {
    return (
        <div className='w-full bg-black mt-8 flex flex-col items-center justify-center'>

            <div className='w-[80%] flex flex-col items-center justify-center my-2 md:my-4'>
                <div className='w-40 h-auto my-4 md:my-8'>
                    <img src="/Mingoli.png" alt="Logo" className="w-full h-auto object-contain" />
                </div>

                <h1 className="text-lg text-white font-inter font-semibold my-3 md:my-6">A World of Sounds</h1>

                <a href='#'>
                <div className='flex items-center justify-center gap-x-3 bg-white bg-opacity-10 rounded-xl py-4 px-6 text-white my-3 md:my-6 cursor-pointer hover:scale-105'>
                    <MdOutlineEmail size={24} />
                    <p className="text-md-font-inter">hello@mingoli.com</p>
                </div>
                </a>

                <nav className='my-2 md:my-4'>
                    <ul className='flex items-center justify-center gap-x-4 text-md md:text-lg text-white'>
                        <li><a href="#">Features</a></li>
                        <li><a href="#">FAQ</a></li>
                        <li><a href="#">Contact</a></li>

                    </ul>
                </nav>

                <hr className="border border-white border-opacity-10 my-2 w-full" />

                <nav className='my-4'>
                    <ul className='flex items-center justify-center gap-x-4 text-lg text-white'>
                        <li><a href="#">
                            <div className='p-3 bg-white bg-opacity-10 rounded-lg '>
                                <FaLinkedin size={28} />
                            </div>
                        </a></li>
                        <li><a href="#">
                            <div className='p-3 bg-white bg-opacity-10 rounded-lg'>
                                <FaXTwitter size={28} />
                            </div>
                        </a></li>
                        <li><a href="#">
                            <div className='p-3 bg-white bg-opacity-10 rounded-lg'>
                                <PiInstagramLogoFill size={28} />
                            </div>
                        </a></li>

                    </ul>
                </nav>

            </div>

        </div>
    )
}

export default Footer